import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class ContactFieldForm extends React.Component {

  static propTypes = {
    config: PropTypes.object,
    fields: PropTypes.array,
    onDone: PropTypes.func,
    onUpdate: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: null
  }

  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    this.setState({
      config: {
        ...this._getDefault(),
        ...this.props.config
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this.props.onUpdate(config)
    }
  }

  _getForm() {
    return {
      ref: this.formRef,
      title: 't(Contact Field)',
      onChange: this._handleChange,
      onSubmit: this._handleDone,
      cancelText: null,
      saveText: null,
      buttons: [
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      sections: [
        {
          fields: this._getContactFields()
        }
      ]
    }
  }

  _getContactFields() {
    const { config } = this.state
    const { type } = config.contactfield
    const fields = [
      { label: 't(Name)', name: 'name', type: 'tokenfield', required: true, value: config.name  },
      { label: 't(Label)', name: 'label', type: 'textfield', value: config.label },
      { label: 't(Instructions)', name: 'instructions', type: 'htmlfield', value: config.instructions },
      { label: 't(Placeholder)', name: 'placeholder', type: 'textfield', value: config.placeholder },
      { label: 't(Required)', name: 'required', type: 'checkbox', prompt: 't(This field is required)', value: config.required }
    ]
    if(type === 'checkbox') {
      fields.push({ label: 't(Prompt)', name: 'prompt', type: 'htmlfield', value: config.prompt || prompt })
    }
    return fields
  }

  _getDefault() {
    return {
      name: null,
      label: null,
      instructions: '',
      required: false,
      contactfield: null,
      overwrite: true
    }
  }

  _handleChange(config) {
    const { label } = config
    const name = _.get(config, 'name.value')
    this.setState({
      config: {
        ...this.state.config,
        ...config,
        ...config.name && ((!label && name.length === 1) || name.slice(0,-1) === label) ? {
          label: config.name.value
        } : {}
      }
    })
  }

  _handleDone() {
    this.props.onDone()
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

}

export default ContactFieldForm
